import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      title: 'Trademark Prosecution',
      description: 'Brazilian filings, classification and specification review, local representation, routine docket monitoring and reporting. Substantive responses are quoted separately.',
      icon: '🏷️',
    },
    {
      title: 'Industrial Design',
      description: 'Essential for product exporters. We protect the visual identity and ornamental aspects of your products against copycats in the Brazilian market.',
      icon: '🎨',
    },
    {
      title: 'Administrative Defense & Appeals',
      description: 'Our team prepares administrative responses, oppositions and appeals under separately approved instructions and fees; outcomes cannot be guaranteed.',
      icon: '⚖️',
    },
    {
      title: 'Brazil Trademark Watch',
      description: "Weekly check of Brazil's trademark gazette with specialist-reviewed conflict alerts. 12 months included with every filing; then US$ 150 per mark per year.",
      icon: '🛡️',
      link: '/brazil-watch',
    },
  ];

  return (
    <section id="solutions" className="py-20 bg-background-auxiliary scroll-mt-24 relative">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-text mb-4">
            Solutions we offer
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-background-white rounded-2xl p-8 hover:shadow-md border border-gray-100/50 hover:border-primary/30 group"
            >
              <div className="mb-5 text-5xl">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-text mb-4">
                {service.title}
              </h3>
              <p className="text-text/70 leading-relaxed text-base">
                {service.description}
              </p>
              {service.link && (
                <Link
                  to={service.link}
                  className="inline-block mt-4 text-primary hover:text-primary-hover font-semibold"
                >
                  See Brazil Watch →
                </Link>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <p className="text-xl md:text-2xl text-text/80 mb-8 max-w-2xl mx-auto">
          Specialist Brazilian trademark representation, with clearly defined scope and advance-paid professional and official fees. Associate arrangements are agreed in writing.
          </p>
          <Link
            to="/order"
            className="inline-block bg-primary text-white px-10 py-4 rounded-xl hover:bg-primary-hover font-semibold shadow-md hover:shadow-lg"
          >
            Start Application
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
